export default __webpack_public_path__ + "static/media/box-open.08ea7166.svg";